import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import SecondHeader from "../components/SecondHeader";
import Navbar from "../components/Navbar";
import SongCover from "../components/Music/SongCover";
import { IoIosArrowForward } from "react-icons/io";
import { SiApplemusic, SiSpotify } from "react-icons/si";
import DialogAlbum from "../components/DialogAlbum";
import VideoHeader from "../components/VideoHeader";

export default function Home(props) {
  const losBorjasTour = [
    {
      poster_url: "./events/los-borjas-2025.jpeg",
      place: "Madrid | 3 Julio",
      url: "https://www.tomaticket.es/es-es/artista/los-borjas",
      last: false,
    },
    {
      poster_url: "./events/los-borjas-2025.jpeg",
      place: "Barcelona | 4 Julio",
      url: "https://www.tomaticket.es/es-es/artista/los-borjas",
      last: false,
    },
    {
      poster_url: "./events/los-borjas-2025.jpeg",
      place: "Tenerife | 5 Julio",
      url: "https://www.tomaticket.es/es-es/artista/los-borjas",
      last: true,
    },
  ];
  const events = [
    // {
    //   poster_url: "./events/2025/14-03.jpeg",
    //   place: "Santo Domingo | 14 Marzo",
    //   url: "https://www.boletosexpress.com/ronald-borjas/80369/?fbclid=PAZXh0bgNhZW0CMTEAAaaFyM8ZbLX17tgeOxj_lE4SY8oIuptqU85VBrx_8WMh6oBy9RkUTuoYXdg_aem_exYJKHT4sWxxbv9bJv_iyQ",
    //   disabled: false,
    // },
    {
      poster_url: "./events/2025/11-12.jpeg",
      place: "Miami | 11 Diciembre",
      url: "https://www.ticketmaster.com/rey-ruiz-and-ronald-borjas-hollywood-florida-12-11-2025/event/0D0062FCBA0517DB",
      disabled: false,
      soldOut: false,
    },
    {
      poster_url: "./events/2025/13-12.jpeg",
      place: "Houston | 13 Diciembre",
      url: "https://www.ticketmaster.com/rey-ruiz-ronald-borjas-houston-texas-12-13-2025/event/3A0062D2E2315CB9",
      disabled: false,
      soldOut: false,
    },
    {
      poster_url: "./events/2025/19-12.jpeg",
      place: "Caracas | 19 Diciembre",
      url: "https://tickets.vibraproductions.com/checkout/ronald-borjas-en-intimo-202512192000?fbclid=PAdGRleAN7ZA5leHRuA2FlbQIxMQBzcnRjBmFwcF9pZA8xMjQwMjQ1NzQyODc0MTQAAafak45UOIWd3u2gpQWLE_6spayovWyiumZkXsQcjUdgpqaAxl5HaW254i-J-g_aem_fM8fYWGcj-y1f2UIEadEBg",
      disabled: false,
      soldOut: false,
    },
    {
      poster_url: "./events/2025/20-12.jpeg",
      place: "Maracay | 20 Diciembre",
      url: "https://wa.me/584243163662?text=Hola%2C+quiero+comprar+entradas+para+el+concierto+de+Ronald+Borjas+en+Maracay.+Por+favor%2C+env%C3%ADame+m%C3%A1s+informaci%C3%B3n.",
      disabled: false,
      soldOut: false,
    },
    {
      poster_url: "./events/2025/26-12.jpeg",
      place: "Maracaibo | 26 Diciembre",
      url: "https://www.mdticket.com/tienda/compra/evento/ronaldborjasenconcierto/",
      disabled: false,
      soldOut: false,
      last: false,
    },
    {
      poster_url: "./events/2025/30-12.jpeg",
      place: "Valencia | 30 Diciembre",
      url: "https://ventas.kreatickets.com/venta/ve?fbclid=PAdGRleAN7Y_JleHRuA2FlbQIxMQBzcnRjBmFwcF9pZA8xMjQwMjQ1NzQyODc0MTQAAacELj14auxUojGucwHivpiP0o_SV1Nf6cQwT3BAJkEQiBMITjyTQ20exwle5g_aem_UR5L6E1M3L-zcDQY0XIrhA",
      disabled: false,
      soldOut: false,
      last: true,
    },
    
    // {
    //   poster_url: "./events/2025/21-03.jpeg",
    //   place: "Buenos Aires | 21 Marzo",
    //   url: "https://www.passline.com/eventos/los-pikis-en-buenos-aires",
    //   disabled: true,
    //   soldOut: true,
    // },
    // {
    //   poster_url: "./events/2025/22-03.jpeg",
    //   place: "Santiago | 22 Marzo",
    //   url: "https://www.puntoticket.com/los-Pikis",
    //   disabled: true,
    //   soldOut: true,
    // },
    // {
    //   poster_url: "./events/2025/28-03.jpeg",
    //   place: "Panama | 28 Marzo",
    //   url: "https://www.passline.com/eventos/los-pikis-en-panama",
    //   disabled: true,
    //   ended: true,
    //   last: true,
    // },
  ];
  useEffect(() => {
    document.title = props.title || "";
    setTimeout(() => {
      if (window.location.hash === "#conciertos") {
        const element = document.getElementById("conciertos");
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      } else if (window.location.hash === "#los-borjas") {
        const element = document.getElementById("los-borjas");
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }
    }, 1000);
  }, [props.title, window.location]);
  return (
    <div>
      <DialogAlbum />
      {/* <Header /> */}
      {/* <div className="divider bg-[#000] h-[50px]"></div>
      <div
        id="music"
        className='bg-fixed mt-[-25px] bg-[url("./assets/joyas-bg.jpg")] bg-cover bg-end md:bg-center py-[150px] flex flex-col justify-center px-[5%] z-10'
      >
        <div className="xl:container mx-auto">
          <h1 className="text-white font-bold text-5xl uppercase">
            Joyas que bailan
          </h1>
          <hr className="text-white font-bold text-5xl mb-8 pb-2 border-t-[3px] border-[#DAFF00] w-52 mt-2" />
          <div className="grid grid-cols-1 md:grid-cols-3 items-center gap-12 justify-center">
            <SongCover
              imgUrl="./joyas-que-bailan.jpeg"
              title="Te mentiría"
              spotify="https://open.spotify.com/track/1rtxjLsNE7WKVkZjDwYTwe?si=90f5e6c53101446b"
              appleMusic="https://music.apple.com/co/album/te-mentir%C3%ADa/1741987371?i=1741987374"
              youtube="https://www.youtube.com/watch?v=rbX24o742Ww"
            />
            <SongCover
              imgUrl="./joyas-que-bailan.jpeg"
              title="Atado a Tu Amor"
              spotify="https://open.spotify.com/track/3ZmpNK5R50513ncyEv4ynd?si=973e9acc9b794273"
              appleMusic="https://music.apple.com/co/album/atado-a-tu-amor/1741987371?i=1741987375"
              youtube="https://www.youtube.com/watch?v=Pm37pueEmqU"
            />
            <SongCover
              imgUrl="./joyas-que-bailan.jpeg"
              title="Desnuda"
              spotify="https://open.spotify.com/track/3NnFUiVf0Spt31xexxJPwf?si=e579dc21a6a74da2"
              appleMusic="https://music.apple.com/co/album/desnuda/1741987371?i=1741987376"
              youtube="https://www.youtube.com/watch?v=SFE34Dr3fL8"
            />
            <div className="flex justify-center md:justify-center grid-cols-1 md:col-span-3">
              <Link
                to="/music"
                className="bg-white text-black px-4 flex items-center text-md w-[260px] justify-center py-4 font-semibold rounded-2xl px-8 cursor-pointer hover:bg-black hover:text-[#DAFF00] transition duration-300 hover:ring-[1px] ring-[#DAFF00]"
              >
                Ver todo el album
              </Link>
            </div>
          </div>
        </div>
      </div> */}
      <div className="divider-2 bg-[#000] h-[50px]"></div>
      <div
        id="music"
        className='mt-[-25px] bg-[url("./assets/music-bg.jpg")] bg-cover bg-end md:bg-center py-[150px] flex flex-col justify-center px-[5%]'
      >
        <div className="xl:container mx-auto">
          <h1 className="text-white font-bold text-5xl mb-8 pb-2 border-b-[3px] border-[#DAFF00] w-20">
            Música
          </h1>
          <div className="grid grid-cols-1 md:grid-cols-3 items-center gap-12 justify-center">
            <SongCover
              imgUrl="./la-noche.jpg"
              title="La Noche"
              spotify="https://open.spotify.com/track/7hbwgVDmOfNqytHP7x72NQ?si=9aff0a6713ef4b63"
              appleMusic="https://music.apple.com/co/song/la-noche/1810934464"
            />
            <SongCover
              imgUrl="./joyas-que-bailan.jpeg"
              title="Te mentiría"
              spotify="https://open.spotify.com/track/1rtxjLsNE7WKVkZjDwYTwe?si=90f5e6c53101446b"
              appleMusic="https://music.apple.com/co/album/te-mentir%C3%ADa/1741987371?i=1741987374"
              youtube="https://www.youtube.com/watch?v=rbX24o742Ww"
            />
            <SongCover
              imgUrl="./me-descontrola.jpeg"
              title="Me Descontrola"
              spotify="https://open.spotify.com/track/34flp1Hbl6EkI6fudYKiHS?si=5beb8463fe264d7f"
              appleMusic="https://music.apple.com/us/album/me-descontrola/1610779339?i=1610779340"
              youtube="https://www.youtube.com/watch?v=M7oZquZM8to"
            />
            <div className="flex justify-center md:justify-center grid-cols-1 md:col-span-3">
              <div className="bg-white text-black px-4 flex items-center text-sm w-[260px] justify-between py-4 font-semibold rounded-2xl px-8">
                Escúchame en
                <div className="flex w-[70px] justify-between">
                  <a
                    href="https://open.spotify.com/artist/1c8m6rFeA6QIhImbIaZ7k2"
                    target="_blank"
                  >
                    <SiSpotify size="30px" className="text-[#1db954]" />
                  </a>
                  <a
                    href="https://music.apple.com/ba/artist/ronald-borjas/463001114"
                    target="_blank"
                  >
                    <SiApplemusic size="30px" className="text-[#fc3c44]" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="divider-2 bg-[#000] h-[50px]"></div>

      {/* <div className="flex flex-col justify-center pl-[5%] pt-[100px] md:pt-0">
        <div className="" id="los-borjas-tour">
          <div className="h-full grid grid-cols-1 md:grid-cols-9 items-start gap-2 justify-center bg-black bg-cover bg-[url('./assets/los-borjas-2.jpg')] bg-no-repeat bg-fixed">
            <div className="col-span-1 md:col-span-5 w-full justify-between items-center z-10 pr-[5%] md:pr-0 py-3">
              <div className="col-span-3 my-10">
                <h1 className="text-white font-bold text-5xl pb-2 border-b-[3px] border-[#DAFF00] w-100">
                  LOS BORJAS TOUR EUROPA 2025
                </h1>
              </div> */}
              {/* {events.slice(0,2).map( ({poster_url, place, url}) => { */}
              {/* {losBorjasTour.map(
                ({ poster_url, place, url, disabled, last }) => {
                  return (
                    <div
                      className={
                        "grid grid-cols-3 text-white font-semibold text-sm md:text-lg col-span-5 w-full justify-between items-center py-5" +
                        (!last ? " border-b-[1px]" : " ")
                      }
                    >
                      <div>
                        <img
                          className="w-[80px] md:w-[150px]"
                          src={poster_url}
                        />
                      </div>
                      <div>{place}</div>
                      <div>
                        {!disabled ? (
                          <a href={url} target="_blank" disabled={true}>
                            <div className="text-center text-xs md:text-sm py-3 px-2 md:py-3 ring-1 md:ring-2 hover:bg-white hover:text-black ring-white rounded-full hover:border-opacity">
                              Comprar tickets
                            </div>
                          </a>
                        ) : (
                          <div href={url} target="_blank" disabled={true}>
                            <div className="text-center text-xs md:text-sm py-3 px-2 md:py-3 ring-1 md:ring-2 ring-white rounded-full ">
                              SOLD OUT
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                }
              )} */}
            {/* </div>
          </div>
        </div>
      </div> */}
      <div className="flex flex-col justify-center pl-[5%] pt-[100px] md:pt-0">
        <div className="" id="conciertos">
          {/* ============================================================================================================ */}

          {/* ======================================================================================== */}
          <div className="grid grid-cols-1 md:grid-cols-9 items-end gap-2 justify-center bg-black bg-[url('./assets/bg-conciertos.jpg')] bg-no-repeat">
            <div className="col-span-1 md:col-span-5 w-full justify-between items-center z-10 pr-[5%] md:pr-0 py-3">
              <div className="col-span-3 my-10">
                <h1 className="text-white font-bold text-5xl pb-2 border-b-[3px] border-[#DAFF00] w-20">
                  Conciertos
                </h1>
              </div>
              {/* {events.slice(0,2).map( ({poster_url, place, url}) => { */}
              {events.map(
                ({ poster_url, place, url, disabled, last, ended }) => {
                  return (
                    <div
                      className={
                        "grid grid-cols-3 text-white font-semibold text-sm md:text-lg col-span-5 w-full justify-between items-center py-5" +
                        (!last ? " border-b-[1px]" : " ")
                      }
                    >
                      <div>
                        <img
                          className="w-[80px] md:w-[150px]"
                          src={poster_url}
                        />
                      </div>
                      <div>{place}</div>
                      <div>
                        {!disabled ? (
                          <a href={url} target="_blank" disabled={true}>
                            <div className="text-center text-xs md:text-sm py-3 px-2 md:py-3 ring-1 md:ring-2 hover:bg-white hover:text-black ring-white rounded-full hover:border-opacity">
                              Comprar tickets
                            </div>
                          </a>
                        ) : (
                          <div href={url} target="_blank" disabled={true}>
                            <div className="text-center text-xs md:text-sm py-3 px-2 md:py-3 ring-1 md:ring-2 ring-white rounded-full ">
                              {ended ? "FINALIZADO" : "SOLD OUT"}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                }
              )}
              {/* <Link to='/events' className='flex justify-end'>
                  <div className='text-white hover:text-[#c2c2c2] flex items-center text-sm w-[180px] justify-between py-4 font-semibold'>
                      Ver mas eventos <IoIosArrowForward size='26px' />
                  </div>
              </Link> */}
            </div>
            <div className="col-span-1 md:col-span-4 mt-[-20px] md:mt-0 z-0 md:flex md:justify-end">
              <img className="" src="/events.png" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
